<template>
  <b-tab
    title="Cliente"
    :active="isTheCurrentTab"
    @click="() => (store.currentTab = 0)"
    :disabled="!isTheCurrentTab && !store.isUpdate"
  >
    <b-row>
      <b-col md="5">
        <b-form-group label="Cliente" label-for="nome">
          <VueSelect
            ref="buscarCliente"
            :filterable="false"
            :state="validateClienteState('nome')"
            @input="setCliente"
            :class="{ hasErrors: clienteError, inputFilled: clienteFilled }"
            :options="clientes"
            @search="onSearchCliente"
            v-model="form.nome"
          >
            <template slot="no-options"> Informe o nome do cliente </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>{{ option.codigo }} - {{ option.nome }}</div>
                <span class="text-muted"
                  >CPF: {{ formatCpfCnpj(option.cnpj_cpf) }}</span
                >
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="CPF/CNPJ" label-for="cnpj_cpf">
          <b-form-input
            v-if="hasCnpjAlfanumerico(form.cnpj_cpf)"
            :key="`${keyToReRender}-alfa`"
            disabled
            id="cnpj_cpf"
            name="cnpj_cpf"
            :value="formatCnpjAlfanumerico(form.cnpj_cpf)"
          >
          </b-form-input>
          <b-form-input
            v-else
            :key="`${keyToReRender}-numeric`"
            disabled
            id="cnpj_cpf"
            name="cnpj_cpf"
            v-mask="['###.###.###-##', '###.###.###/####-##']"
            v-model="form.cnpj_cpf"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="10" v-if="form?.enderecos">
        <b-form-group
          :key="keyToReRender"
          label="Endereço"
          label-for="endereco"
        >
          <b-form-input
            disabled
            id="endereco"
            name="endereco"
            :value="formatEndereco(form?.enderecos[0])"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <b-form-group label="Solicitante" label-for="solicitante">
          <b-form-input
            id="solicitante"
            name="solicitante"
            v-model="solicitante"
            @input="setSolicitante"
            maxlength="50"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="5">
        <b-form-group label="Vendedor" label-for="vendedor">
          <VueSelect
            ref="buscaVendedor"
            :filterable="false"
            @input="setVendedor"
            :options="vendedores"
            v-model="vendedor"
            @search="onSearchVendedor"
          >
            <template slot="no-options"> Informe o nome do vendedor </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.nome }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.nome }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <button
          ref="add_buyer"
          class="btn btn-primary font-weight-bold"
          v-b-modal.newClient
          style="font-size: 11px; margin-top: 30px"
        >
          Novo Cliente
        </button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4" style="margin-top: 20px" v-if="form.tipo_atacado">
        <span class="label label-lg label-inline label-light-warning"
          >Tipo Atacado</span
        >
      </b-col>
    </b-row>
    <b-row v-if="limiteCreditoAtigindo" style="margin-top: 5px">
      <b-col sm="12">
        <span class="label label-lg label-inline label-light-danger"
          >Limite de crédito atingido</span
        >
        -
        <span
          ><strong
            >Limite: R$ {{ numberToReal(valorLimiteCredito, 2) }}</strong
          ></span
        >
        /
        <span
          v-b-tooltip.righttop="
            'O limite de crédito considera contas a receber na situação (Em aberto)'
          "
          ><strong
            >Atingido: R$
            {{ numberToReal(valorLimiteCreditoAtingido, 2) }}</strong
          ></span
        >
      </b-col>
    </b-row>

    <b-row v-if="listaPreco">
      <b-col>
        <p class="text-muted">
          Lista de preço aplicada:
          <span class="font-weight-bold text-primary">{{
            listaPreco.descricao
          }}</span>
        </p>
      </b-col>
    </b-row>

    <NovoClienteModal
      modal-id="newClient"
      @selected="handleNovoClienteSelected"
    />
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storePedidos";
import ClienteData, { ClienteDataRequired } from "../ClienteData";
import NovoClienteModal from "@/modules/Pessoa/components/NovoClienteModal.vue";

export default {
  name: "app-pedido-form-clienteTab",
  components: {
    VueSelect,
    NovoClienteModal,
  },
  directives: {
    mask,
  },
  data() {
    return {
      form: {},
      listaPreco: null,
      clientes: [],
      cliente: null,
      vendedor: null,
      solicitante: null,
      keyToReRender: 0,
      store,
      vendedores: [],
      clienteError: false,
      enderecoError: false,
      clienteFilled: false,
      limiteCreditoAtigindo: false,
      valorLimiteCredito: 0,
      valorLimiteCreditoAtingido: 0,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  validations: {
    form: ClienteDataRequired,
  },
  methods: {
    ...mapActions(["setLoading"]),
    handleLoading(value) {
      this.setLoading(value);
    },
    onSearchCliente(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    validateClienteState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setVendedor(vendedor) {
      this.store.formCliente.vendedor = vendedor.id_vendedor;
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getClientes(search);
      loading(false);
    }, 350),
    onSearchVendedor(search, loading) {
      if (search.length) {
        loading(true);
        this.searchVendedor(loading, search, this);
      }
    },
    searchVendedor: _.debounce(async (loading, search, vm) => {
      vm.vendedores = await vm.getVendedorByNome(search);
      if (loading) loading(false);
    }, 350),
    handleNovoClienteSelected(cliente) {
      this.setCliente(cliente);
    },
    setCliente(cliente) {
      if (!cliente) return;
      if (this.bloquearClienteInadimplenteSelecionado(cliente)) {
        this.form = {};
        this.clienteFilled = false;
        return;
      }

      this.limiteCreditoAtigindo = false;
      this.valorLimiteCredito = 0;
      this.limiteCreditoAtigindo = 0;
      this.listaPreco = null;

      if (cliente?.lista_preco) {
        this.listaPreco = cliente.lista_preco;
      }

      if (this.currentUser.vendedor) {
        if (!this.$route.params.pedidoData?.vendedor) {
          this.vendedor = this.currentUser.vendedor;
          this.store.formCliente.vendedor =
            this.currentUser.vendedor.id_vendedor;
        }
      }

      if (
        Object.keys(this.$route.params).length === 0 ||
        this.$route.params.pedidoData.cliente.id_pessoa != cliente.id_pessoa
      ) {
        if (parseFloat(cliente.limite_credito) > 0) {
          if (
            cliente.limite_de_credito &&
            parseFloat(cliente.limite_credito) <
              parseFloat(cliente.limite_de_credito.valor_total)
          ) {
            this.$toast.warning(
              "Limite de crédito do cliente atingido, verifique!"
            );
            this.getRequestAdmin(() => {
              this.setClienteInadimplente(cliente);
            });
            return;
          }
        }
      }

      this.form = cliente;
      this.clienteFilled = true;
      if (Object.keys(this.$route.params).length !== 0) {
        this.solicitante = this.$route.params.pedidoData?.solicitante ?? "";
      }
    },
    setClienteInadimplente(cliente) {
      this.limiteCreditoAtigindo = true;
      this.valorLimiteCredito = cliente.limite_credito;
      this.valorLimiteCreditoAtingido = cliente.limite_de_credito.valor_total;
      this.form = cliente;
      this.clienteFilled = true;
      if (Object.keys(this.$route.params).length !== 0) {
        this.solicitante = this.$route.params.pedidoData?.solicitante ?? "";
      }
    },
    setSolicitante(solicitante) {
      this.store.formCliente.solicitante = solicitante;
    },
    formatEndereco(endereco) {
      if (!endereco) return "";
      const formatData = `${endereco.cep ?? ""}, ${
        endereco.logradouro ?? ""
      }, ${endereco.numero ?? ""}, ${endereco.bairro ?? ""} - ${
        endereco?.cidade?.cidade ?? ""
      } / ${endereco?.cidade?.uf ?? ""}`;
      return formatData;
    },
  },
  async created() {
    this.tipoEndereco = await this.getTipoEndereco();
    if (Object.keys(this.$route.params).length !== 0) {
      this.handleLoading(true);
      const id_pessoa = this.$route.params.pedidoData.cliente.id_pessoa;
      this.vendedor = this.$route.params.pedidoData?.vendedor;

      if (!this.vendedor) {
        if (this.currentUser.vendedor) {
          this.vendedor = this.currentUser.vendedor;
          this.store.formCliente.vendedor =
            this.currentUser.vendedor.id_vendedor;
        }
      }

      this.solicitante = this.$route.params.pedidoData?.solicitante;
      this.store.formCliente.solicitante =
        this.$route.params.pedidoData?.solicitante;
      this.$http
        .post("/pessoa/find", {
          id_pessoa,
        })
        .then((response) => {
          this.setCliente(response.data);
        })
        .catch((error) =>
          this.$toast.error(`Erro ao buscar cliente:\n${error}`)
        );
      this.handleLoading(false);
    } else {
      this.vendedor = null;

      if (this.currentUser.vendedor) {
        this.vendedor = this.currentUser.vendedor;
      }

      this.solicitante = null;
      this.store.formCliente.solicitante = null;
      this.store.formCliente.vendedor = null;
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    ...mapState({
      currentUser: (state) => state.auth.vendedor,
    }),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 0;
    },
  },
  watch: {
    "store.formCliente"(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.form = newValue;
        this.solicitante = newValue?.solicitante ?? this.solicitante;
        if (newValue?.vendedorSelecionado) {
          this.vendedor = newValue.vendedorSelecionado;
        }
        this.keyToReRender++;
      }
    },
    form: {
      handler(newValue) {
        this.store.formCliente = {
          ...this.store.formCliente,
          ...newValue,
        };
      },
      deep: true,
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 1 && oldValue < newValue) {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          if (this.$v.form.$anyError) {
            this.store.currentTab = oldValue;
            if (this.$v.form.nome.$anyError) {
              this.$toast.error("Informe o cliente!");
              this.clienteError = true;
            }
          }
          return;
        }
      }
    },
  },
};
</script>
